import { Component, Input } from '@angular/core';
import { AvailableDataColumn } from '../../models/grid';
@Component({
    selector: 'cdp-grid-cell',
    templateUrl: 'grid-cell.component.html',
    styleUrls: ['./grid-cell.component.scss'],
    standalone: false
})
export class GridCellComponent<T> {
    @Input() element: any;
    @Input() column: AvailableDataColumn<T>;
    @Input() searchTerm: string;
    @Input() isDisabled: boolean;

    evaluateColumnExpression(columnExpression: string | ((element: T) => string), element: T): string {
        if (typeof columnExpression === 'string') {
            return columnExpression;
        } else {
            return columnExpression(element);
        }
    }
}
